import * as React from "react";

import {
  TrackingProvider as Provider,
  createEventTracker,
  configureTracking,
} from "@zapier/toolbox-tracking";

configureTracking({
  // This has to be 'web' see following slack thread
  // https://zapier.slack.com/archives/C406QGE15/p1605895155293500
  service: "web",
  release: `${process.env.NEXT_PUBLIC_COMMIT_SHA}`,
});

const trackingFunctions = createEventTracker();

type Props = {
  children: React.ReactNode;
};

export function TrackingProvider({ children }: Props) {
  return <Provider trackingFunctions={trackingFunctions}>{children}</Provider>;
}
